// PHASE 2: How do you spend most of your time at home?
import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../../hooks/useUpdateMode'
import { saveAnswer } from '../../../utils/onboardingStorage'

const QUESTION_KEY = 'lifestyleContext'

const OPTIONS = [
  {
    value: 'Working from home',
    translationKey: 'pages.onboarding.v2.lifestyleContext.options.working',
    emoji: '💻',
  },
  {
    value: 'Relaxing and unwinding',
    translationKey: 'pages.onboarding.v2.lifestyleContext.options.relaxing',
    emoji: '🛋️',
  },
  {
    value: 'Hosting friends and family',
    translationKey: 'pages.onboarding.v2.lifestyleContext.options.hosting',
    emoji: '🥂',
  },
  {
    value: 'Pursuing hobbies and creativity',
    translationKey: 'pages.onboarding.v2.lifestyleContext.options.hobbies',
    emoji: '🎨',
  },
  {
    value: 'Caring for family',
    translationKey: 'pages.onboarding.v2.lifestyleContext.options.family',
    emoji: '👨‍👩‍👧',
  },
  {
    value: 'A mix of everything',
    translationKey: 'pages.onboarding.v2.lifestyleContext.options.mix',
    emoji: '🌈',
  },
]

export default function LifestyleContextPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How do you spend most of your time at home?',
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  const buttons = OPTIONS.map((option) => ({
    text: `${option.emoji} ${t(option.translationKey)}`,
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.v2.lifestyleContext.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
